import React from 'react';

const ErrorIcon: React.FC = () => (
    <path d="M8.266 11.94H10.1v1.837H8.266zm0-7.348H10.1V10.1H8.266zM9.175 0a9.184 9.184 0 109.194 9.184A9.18 9.18 0 009.175 0zm.009 16.532a7.348 7.348 0 117.348-7.348 7.346 7.346 0 01-7.348 7.348z"/>
)

export default ErrorIcon;
